import { render, staticRenderFns } from "./MsNavbar.vue?vue&type=template&id=ed7455de&scoped=true"
import script from "./MsNavbar.vue?vue&type=script&lang=js"
export * from "./MsNavbar.vue?vue&type=script&lang=js"
import style0 from "./MsNavbar.vue?vue&type=style&index=0&id=ed7455de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7455de",
  null
  
)

export default component.exports